import React from 'react';
import classNames from 'classnames';
import { shape, string, number } from 'prop-types';
import { formatPhoneNumber } from '../../utils/helpers';

import styles from './StoreCard.module.scss';

export const StoreCard = ({ store }) => {
  const {
    availableQty, name, phone, storeId, address, toolRentalPhone, services
  } = store;
  const { street, city, state, postalCode } = address;
  const { toolRental } = services;
  return (
    <>
      <div className={classNames(styles['rental-fulfillment__location'])}>
        <div className="u--paddingBottom">
          <b>{ toolRental ? 'Your Nearest Rental Center is:' : 'Your Nearest Store is:' }</b>
        </div>
        <div className={classNames(styles['rental-fulfillment__location--row'])}>
          {(availableQty === 0 || availableQty === null) && (
            <span className={classNames(styles['rental-fulfillment__location--row__danger'])}>
              <span className={classNames(styles['rental-fulfillment__location--row__bold'])}>
                0
              </span>
              &nbsp;Currently Available
            </span>
          )}
          {availableQty > 0 && (
            <span className="alert-inline alert-inline--success">
              <span className="alert-inline__message">{availableQty} Currently Available</span>
            </span>
          )}
          <div className="u__bold">
            &nbsp;at {name} #{storeId}
          </div>
        </div>
        <span>
          {street}, {city}, {state}, {postalCode}
        </span>
      </div>
      <div className={classNames(styles['rental-fulfillment__store-info'])}>
        <div>
          { !toolRentalPhone ? `Phone: ${formatPhoneNumber(phone)}`
            : `Rental: ${formatPhoneNumber(toolRentalPhone)}` }
        </div>
      </div>
    </>
  );
};

StoreCard.propTypes = {
  store: shape({
    name: string,
    storeId: string,
    distance: number,
    toolRentalPhone: string,
    address: shape({
      street: string,
      city: string,
      state: string,
      postalCode: string,
    }),
  }).isRequired
};
